/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateInstrumentLinkStatuses} from '../api'

export const useMutationUpdateInstrumentLinkStatuses = createReactQueryMutationHook('updateInstrumentLinkStatuses', updateInstrumentLinkStatuses)
